export default __webpack_public_path__ + "static/media/gallery_01.be5aa5f9.jpg";